import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
  },

  {
    path: '/pastoral-team',
    name: 'PastoralTeam',
    component: () => import('../views/PastoralTeam.vue'),
  },


  {
    path: '/parish-history',
    name: 'PastoralTeam',
    component: () => import('../views/ParishHistory.vue'),
  },

  {
    path: '/parish-activities',
    name: 'PastoralActivities',
    component: () => import('../views/ParishHistory.vue'),
  },
  {
    path: '/societies',
    name: 'Societies',
    component: () => import('../views/Societies.vue'),
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: () => import('../views/Calendar.vue'),
  },
  {
    path: '/give',
    name: 'Give',
    component: () => import('../views/Give.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
});

export default router;
